import { render, staticRenderFns } from "./OrderForecastReport.vue?vue&type=template&id=4e6779c2"
import script from "./OrderForecastReport.vue?vue&type=script&lang=js"
export * from "./OrderForecastReport.vue?vue&type=script&lang=js"
import style0 from "./OrderForecastReport.vue?vue&type=style&index=0&id=4e6779c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports